import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const LINES = [
  { text: "Redefining Filipino Design.", accent: "#FF8473" },
  { text: "Sourcing remotely with ease.", accent: "#A7D3E8" },
  { text: "Crowdfunding creative ideas.", accent: "#D7E85C" },
  { text: "Designing Real Market Needs.", accent: "#EBC9B5", discover: true },
];

const Word = ({ children, progress, range, accent }) => {
  const opacity = useTransform(progress, range, [0.12, 1]);
  const color = useTransform(progress, [range[0], range[1]], ["#3a3a3a", accent]);
  return (
    <motion.span style={{ opacity, color }} className="mr-[0.25em] inline-block">
      {children}
    </motion.span>
  );
};

const ShiftLine = ({ text, accent, discover }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.9", "start 0.35"] });
  const words = text.split(" ");
  return (
    <div ref={ref} className="relative">
      <p className="font-display font-black uppercase tracking-tighter leading-[0.95] text-[9vw] md:text-[6vw] flex flex-wrap">
        {words.map((w, i) => {
          const start = i / words.length;
          const end = start + 1 / words.length;
          return (
            <Word key={i} progress={scrollYProgress} range={[start, end]} accent={accent}>
              {w}
            </Word>
          );
        })}
      </p>
      {discover && (
        <button
          data-testid="shift-discover-btn"
          onClick={() => document.getElementById("campaign")?.scrollIntoView({ behavior: "smooth" })}
          className="absolute right-0 -bottom-24 md:-bottom-28 inline-flex items-center bg-[#D7E85C] text-[#1F3864] px-7 py-3 rounded-full font-bold uppercase text-sm tracking-wide hover:bg-[#FFFFFF] active:scale-95 transition-[background,transform] duration-200"
        >
          Discover more
        </button>
      )}
    </div>
  );
};

export const Shift = () => (
  <section id="shift" data-testid="shift-section" className="relative">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-24 md:py-48">
      <div className="mb-16 md:mb-28">
        <span className="text-sm font-bold uppercase tracking-[0.25em] text-[#FFFFFF]">
          The Shift
        </span>
      </div>
      <div className="flex flex-col gap-8 md:gap-14">
        {LINES.map((l, i) => (
          <ShiftLine key={i} text={l.text} accent={l.accent} discover={l.discover} />
        ))}
      </div>
    </div>
  </section>
);
